import { EtiquetaDePreco } from '@/models/EtiquetaDePreco'
import print from 'print-js'
import request from '@/common/request'

/*
import pdfMake from 'pdfmake/build/pdfmake'
import JsBarcode from 'jsbarcode'
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces'
import { formatarMoeda } from '../formatadores'
import { displayNomeCompletoDoProduto } from '../produto-shareds'
import { ItemDaTabelaDePreco } from '@/models'
import vfs from 'pdfmake/build/vfs_fonts.js'

window.pdfMake.vfs = vfs.pdfMake.vfs;

function textToBase64Barcode(text: string) {
	const canvas = document.createElement("canvas");
	JsBarcode(canvas, text, {
		displayValue: false,
		margin: 0,
	});
	return canvas.toDataURL("image/png");
}

export async function gerarEtiquetasDeGondola(etiquetas: EtiquetaDePreco[], precoDoProduto: boolean, incluirNome: boolean, imprimirConformeRegraDeNegocioDoCaixa: boolean): Promise<string> {
	let etiquetasPorQuantidade: Content[] = []
	const tamanhoEtiqueta = etiquetas[0].tamanho

	etiquetas.forEach(etiqueta => {
		const etiquetasDeUmaGondola = Array.from(
			{ length: etiqueta.quantidade },
			() => geraEtiquetaDeGondola(etiqueta, precoDoProduto, incluirNome, imprimirConformeRegraDeNegocioDoCaixa),
		)
		etiquetasPorQuantidade = [
			...etiquetasPorQuantidade,
			...etiquetasDeUmaGondola,
		]
	})

	let linhaDeEtiquetas: Content[][] = []
	const larguraPagina = cmParaPontos(tamanhoEtiqueta.larguraPagina)
	const alturaPagina = cmParaPontos(tamanhoEtiqueta.alturaPagina)
	const larguraEtiqueta = cmParaPontos(tamanhoEtiqueta.larguraEtiqueta)
	const alturaEtiqueta = cmParaPontos(tamanhoEtiqueta.alturaEtiqueta)
	const bordaEsquerda = cmParaPontos(tamanhoEtiqueta.bordaEsquerda)
	const bordaTopo = cmParaPontos(tamanhoEtiqueta.bordaDoTopo)
	const distanciaEntreEtiquetas = cmParaPontos(tamanhoEtiqueta.distanciaEntreEtiquetas)

	const etiquetasPorLinha = tamanhoEtiqueta.impressaoUnica 
		? 1 
		: Math.floor((larguraPagina - (bordaEsquerda * 2)) / (larguraEtiqueta + distanciaEntreEtiquetas))

	for (let i = 0; i < etiquetasPorQuantidade.length; i += etiquetasPorLinha) {
		const algumasEtiquetas = etiquetasPorQuantidade.slice(i, i + etiquetasPorLinha)

		while (algumasEtiquetas.length < etiquetasPorLinha) {
			algumasEtiquetas.push({ text: '', width: larguraEtiqueta });
		}

		linhaDeEtiquetas = [
			...linhaDeEtiquetas,
			[
				...algumasEtiquetas,
			],
		]
	}
	
	const pageSize = tamanhoEtiqueta.impressaoUnica 
		? { width: larguraEtiqueta, height: alturaEtiqueta } 
		: { width: larguraPagina, height: alturaPagina }
	console.log("etiquetasPorLinha", etiquetasPorLinha)
	const docDefinition: TDocumentDefinitions = {
		pageSize,
		pageMargins: [bordaEsquerda, bordaTopo, bordaEsquerda, 0],
		content: {
			table: {
				widths: Array(etiquetasPorLinha).fill(larguraEtiqueta),
				body: linhaDeEtiquetas,
				...(tamanhoEtiqueta.impressaoUnica ? {} : { heights: alturaEtiqueta }),
				dontBreakRows: true,
			},
			layout: {
				hLineWidth: () => 0, 
				vLineWidth: () => 0, 
				paddingLeft: () => distanciaEntreEtiquetas, 
				paddingRight: () => 0,
				paddingTop: () => 0, 
				paddingBottom: () => 0,
			},
		},
	}
	return new Promise(resolve => pdfMake.createPdf(docDefinition).getBase64((result) => resolve(result)))
}

export function geraEtiquetaDeGondola(
	etiqueta: EtiquetaDePreco,
	precoDoProduto: boolean,
	incluirNome: boolean,
	imprimirConformeRegraDeNegocioDoCaixa: boolean,
): Content[] {
	
	const larguraEtiqueta = cmParaPontos(etiqueta.tamanho.larguraEtiqueta)
	const alturaEtiqueta = cmParaPontos(etiqueta.tamanho.alturaEtiqueta)
	const fontSize = etiqueta.incluirPreco ? Math.max(6, Math.min(alturaEtiqueta * 0.09, 14)) : Math.max(6, Math.min(alturaEtiqueta * 0.12, 14))

	const larguraCodigoEAN = larguraEtiqueta * 0.3
	const larguraNomeProduto = larguraEtiqueta * 0.7

	const moedaFormatada = etiqueta.produto.preco?.toLocaleString(
		'pt-BR',
		{ style: 'currency', currency: 'BRL' }
	);

	if (imprimirConformeRegraDeNegocioDoCaixa) {
		return [
			{ stack: [{
				columns: [
					{
						width: larguraCodigoEAN,
						fontSize: fontSize,
						text: `${etiqueta.produto.eans[0] || ''}`,
						margin: 0,
					},
					{
						width: larguraNomeProduto,
						fontSize: fontSize,
						text: ` - ${(etiqueta.produto.nomeCompleto || etiqueta.produto.nome)}`,
						margin: 0,
					},
				],
				//columnGap: 1, 
			},
			precoDoProduto
				? etiqueta.precos
					.sort((a, b) => ordenarTiposDeClientePorOrdemAlfabetica(a, b))
					.map<Content>((preco) => ({
						text: formatarPrecoQuantidade(preco, incluirNome),
						bold: true,
						fontSize: fontSize,
						margin: 0,
					}))
				: montarNomeEPrecoDaEtiqueta(incluirNome, etiqueta, precoDoProduto),
			],
			margin:[1, 1, 1, 1],
			}]
	} else {
		return [
			{stack:[{
				columns: [
					{
						width: larguraCodigoEAN,
						fontSize: fontSize,
						text: `${etiqueta.produto.eans[0] || ''}`,
						margin: 0,
					},
					{
						width: larguraNomeProduto,
						fontSize: fontSize,
						text: ` - ${(etiqueta.produto.nomeCompleto || etiqueta.produto.nome)}`,
						margin: 0,
					},
				],
				//columnGap: 1, 
			},
			...etiqueta.precos
				.sort((a, b) => ordenarTiposDeClientePorOrdemAlfabetica(a, b))
				.map<Content>((preco) => ({
					text: formatarPrecoQuantidade(preco, incluirNome),
					bold: true,
					fontSize: fontSize,
					margin: 0,
				})),
			{
				bold: true,
				fontSize: fontSize,
				margin: 0,
				text: `${precoDoProduto ? moedaFormatada : ''}`,
			},
			],
			margin:[1, 1, 1, 1],
			}]
	}
}

export function montarNomeEPrecoDaEtiqueta(incluirNome: boolean, etiqueta: EtiquetaDePreco, precoDoProduto: boolean) {
	const qtdeLimitadaDoProduto = etiqueta.precos.length > 0 && etiqueta.precos[0].qtdeLimitadaDoProduto 
		? ` - Limitações ${etiqueta.precos[0].qtdeLimitadaDoProduto}` 
		: ''

	const nome = incluirNome ? 'Padrão' : ''
	const preco = precoDoProduto ? `R$  ${formatarMoeda(etiqueta.produto.preco ? etiqueta.produto.preco : 0)}` : ''

	return nome + preco + qtdeLimitadaDoProduto
}


export async function gerarEtiquetasDeProduto(
	etiquetas: EtiquetaDePreco[],
	imprimirPrecoDoProduto: boolean,
	imprimirConformeRegraDeNegocioDoCaixa: boolean,
): Promise<string> {
	let etiquetasPorQuantidade: Content[] = []
	const tamanhoEtiqueta = etiquetas[0].tamanho

	etiquetas.forEach(etiqueta => {
		const etiquetasDeUmProduto = Array.from(
			{ length: etiqueta.quantidade},
			() => geraEtiquetaDeProduto(etiqueta, imprimirPrecoDoProduto, imprimirConformeRegraDeNegocioDoCaixa),
		)
		etiquetasPorQuantidade = [
			...etiquetasPorQuantidade,
			...etiquetasDeUmProduto,
		]
	})

	let linhaDeEtiquetas: Content[][] = []
	const larguraPagina = cmParaPontos(tamanhoEtiqueta.larguraPagina)
	const alturaPagina = cmParaPontos(tamanhoEtiqueta.alturaPagina)
	const larguraEtiqueta = cmParaPontos(tamanhoEtiqueta.larguraEtiqueta)
	const alturaEtiqueta = cmParaPontos(tamanhoEtiqueta.alturaEtiqueta)
	const bordaEsquerda = cmParaPontos(tamanhoEtiqueta.bordaEsquerda)
	const bordaTopo = cmParaPontos(tamanhoEtiqueta.bordaDoTopo)
	const distanciaEntreEtiquetas = cmParaPontos(tamanhoEtiqueta.distanciaEntreEtiquetas)
	const etiquetasPorLinha = tamanhoEtiqueta.impressaoUnica 
		? 1 
		: Math.floor((larguraPagina - (bordaEsquerda * 2)) / (larguraEtiqueta + distanciaEntreEtiquetas))

	for (let i = 0; i < etiquetasPorQuantidade.length; i += etiquetasPorLinha) {
		const algumasEtiquetas = etiquetasPorQuantidade.slice(i, i + etiquetasPorLinha)
		const espacosVazios: Content[] = Array.from(
			{ length: etiquetasPorLinha - algumasEtiquetas.length },
			() => [],
		)
		linhaDeEtiquetas = [
			...linhaDeEtiquetas,
			[
				...algumasEtiquetas,
				...espacosVazios,
			],
		]
	}
	
	const pageSize = tamanhoEtiqueta.impressaoUnica 
		? { width: larguraEtiqueta, height: alturaEtiqueta } 
		: { width: larguraPagina, height: alturaPagina }

	const docDefinition: TDocumentDefinitions = {
		pageSize,
		pageMargins: [bordaEsquerda, bordaTopo, bordaEsquerda, 0],
		content: {
			table: {
				widths: Array(etiquetasPorLinha).fill(larguraEtiqueta),
				body: linhaDeEtiquetas,
				...(tamanhoEtiqueta.impressaoUnica ? {} : { heights: alturaEtiqueta }),
				dontBreakRows: true,
			},
			layout: {
				hLineWidth: () => 0, 
				vLineWidth: () => 0, 
				paddingLeft: () => distanciaEntreEtiquetas, 
				paddingRight: () => 0,
				paddingTop: () => 0, 
				paddingBottom: () => 0,
			},
		},
	}
	return new Promise(resolve => {
		pdfMake.createPdf(docDefinition).getBase64((result) => resolve(result))
	})
}

export async function gerarEtiquetasDePrecosDoProduto(etiquetas: EtiquetaDePreco[], precoDoProduto: boolean, incluirNome: boolean, imprimirConformeRegraDeNegocioDoCaixa: boolean): Promise<string> {
	let etiquetasPorQuantidade: Content[] = []
	const tamanhoEtiqueta = etiquetas[0].tamanho

	etiquetas.forEach(etiqueta => {
		const etiquetasDeUmProduto = Array.from(
			{ length: etiqueta.quantidade},
			() => geraEtiquetaDePrecosDoProduto(etiqueta, precoDoProduto, incluirNome, imprimirConformeRegraDeNegocioDoCaixa),
		)
		etiquetasPorQuantidade = [
			...etiquetasPorQuantidade,
			...etiquetasDeUmProduto,
		]
	})

	let linhaDeEtiquetas: Content[][] = []
	const larguraPagina = cmParaPontos(tamanhoEtiqueta.larguraPagina)
	const alturaPagina = cmParaPontos(tamanhoEtiqueta.alturaPagina)
	const larguraEtiqueta = cmParaPontos(tamanhoEtiqueta.larguraEtiqueta)
	const alturaEtiqueta = cmParaPontos(tamanhoEtiqueta.alturaEtiqueta)
	const bordaEsquerda = cmParaPontos(tamanhoEtiqueta.bordaEsquerda)
	const bordaTopo = cmParaPontos(tamanhoEtiqueta.bordaDoTopo)
	const distanciaEntreEtiquetas = cmParaPontos(tamanhoEtiqueta.distanciaEntreEtiquetas)
	const etiquetasPorLinha = tamanhoEtiqueta.impressaoUnica 
		? 1 
		: Math.floor((larguraPagina - (bordaEsquerda * 2)) / (larguraEtiqueta + distanciaEntreEtiquetas))

	for (let i = 0; i < etiquetasPorQuantidade.length; i += etiquetasPorLinha) {
		const algumasEtiquetas = etiquetasPorQuantidade.slice(i, i + etiquetasPorLinha)
		const espacosVazios: Content[] = Array.from(
			{ length: etiquetasPorLinha - algumasEtiquetas.length },
			() => [],
		)
		linhaDeEtiquetas = [
			...linhaDeEtiquetas,
			[
				...algumasEtiquetas,
				...espacosVazios,
			],
		]
	}
	const pageSize = tamanhoEtiqueta.impressaoUnica 
		? { width: larguraEtiqueta, height: alturaEtiqueta } 
		: { width: larguraPagina, height: alturaPagina }

	const docDefinition: TDocumentDefinitions = {
		pageSize,
		pageMargins: [bordaEsquerda, bordaTopo, bordaEsquerda, 0],
		content: {
			table: {
				widths: Array(etiquetasPorLinha).fill(larguraEtiqueta),
				body: linhaDeEtiquetas,
				...(tamanhoEtiqueta.impressaoUnica ? {} : { heights: alturaEtiqueta }),
				dontBreakRows: true,
			},
			layout: {
				hLineWidth: () => 0, 
				vLineWidth: () => 0, 
				paddingLeft: () => distanciaEntreEtiquetas, 
				paddingRight: () => 0,
				paddingTop: () => 0, 
				paddingBottom: () => 0,
			},
		},
	}
	return new Promise(resolve => {
		pdfMake.createPdf(docDefinition).getBase64((result) => resolve(result))
	})
}

export function geraEtiquetaDePrecosDoProduto(etiqueta: EtiquetaDePreco, precoDoProduto: boolean, incluirNome: boolean, imprimirConformeRegraDeNegocioDoCaixa: boolean): Content[] {
	const larguraEtiqueta = cmParaPontos(etiqueta.tamanho.larguraEtiqueta)
	const alturaEtiqueta = cmParaPontos(etiqueta.tamanho.alturaEtiqueta)

	const fontSize = Math.max(6, Math.min(alturaEtiqueta * 0.08, 10))
	const barcodeWidth = larguraEtiqueta * 0.8;
	const barcodeHeight = alturaEtiqueta * 0.3;

	if(imprimirConformeRegraDeNegocioDoCaixa) {
		return [
			{stack: [{
				columns: [
					{
						width: larguraEtiqueta,
						fontSize: fontSize,
						bold: true,
						text: displayNomeCompletoDoProduto(etiqueta.produto).substr(0, 55),
						margin: 0,
					},
				],
			},
			{
				margin: 0,
				image: textToBase64Barcode(etiqueta.produto.eans[0]), width: barcodeWidth, height: barcodeHeight,
			},
			{ 
				bold: true, 
				fontSize: fontSize, 
				margin: 0,
				text: etiqueta.produto.eans[0] || '',
			},
			etiqueta.precos.length && precoDoProduto
				? etiqueta.precos
					.sort((a, b) => ordenarTiposDeClientePorOrdemAlfabetica(a, b))
					.slice(0, 2).map<Content>(preco => ({
						text: formatarPrecoQuantidade(preco, incluirNome),
						bold: true,
						margin: 0,
						fontSize: fontSize,
					})) 
				: montarNomeEPrecoDaEtiqueta(incluirNome, etiqueta, precoDoProduto),
			],
			margin:[1, 1, 1, 1],
			}]
	} else {
		return [
			{ stack:[{
				columns: [
					{
						width: larguraEtiqueta,
						fontSize: fontSize,
						bold: true,
						text: displayNomeCompletoDoProduto(etiqueta.produto).substr(0, 55),
						margin: 0,
					},
				],
			},
			{
				margin: 0,
				image: textToBase64Barcode(etiqueta.produto.eans[0]), width: barcodeWidth, height: barcodeHeight,
			},
			{ 
				bold: true, 
				fontSize: fontSize,
				margin: 0,
				text: `${etiqueta.produto.eans[0] || ''}`, 
			},
			etiqueta.precos.length
				? etiqueta.precos
					.sort((a, b) => ordenarTiposDeClientePorOrdemAlfabetica(a, b))
					.slice(0, 2).map<Content>(preco => ({
						text: formatarPrecoQuantidade(preco, incluirNome),
						bold: true,
						margin: 0,
						fontSize: fontSize,
					})) 
				:
				{
					text: `${'CLUBE'.padEnd(10, ' ')} - Sem preço selecionado\n${'VAREJO'.padEnd(8, ' ')} - Sem preço selecionado`,
					bold: true,
					margin: 0,
					fontSize: fontSize,
				}],
			margin:[1, 1, 1, 1],
			}]
	}
}

export function geraEtiquetaDeProduto(
	etiqueta: EtiquetaDePreco,
	imprimirPrecoDoProduto: boolean,
	imprimirConformeRegraDeNegocioDoCaixa: boolean,
): Content[] {
	const larguraEtiqueta = cmParaPontos(etiqueta.tamanho.larguraEtiqueta)
	const alturaEtiqueta = cmParaPontos(etiqueta.tamanho.alturaEtiqueta)

	const fontSize = Math.max(6, Math.min(alturaEtiqueta * 0.08, 10))

	const barcodeWidth = larguraEtiqueta * 0.8;
	const barcodeHeight = alturaEtiqueta * 0.3;

	const qtdeLimitadaDoProduto = etiqueta.precos.length > 0 && 
			etiqueta.precos[0].qtdeLimitadaDoProduto && 
				etiqueta.precos[0].limitarProduto
		? `- Limitação ${etiqueta.precos[0].qtdeLimitadaDoProduto}` 
		: ''

	if(imprimirConformeRegraDeNegocioDoCaixa) {		
		const preco = etiqueta.precos.map(
			({ precoFinalVarejo }) => precoFinalVarejo.toLocaleString(
				'pt-BR', { style: 'currency', currency: 'BRL' },
			),
		)[0] 
		|| `R$ ${etiqueta.produto.preco} ` 

		return [
			{stack:[{
				columns: [
					{
						width: larguraEtiqueta,
						fontSize,
						bold: true,
						text: displayNomeCompletoDoProduto(etiqueta.produto),
						//margin: [ 0, 2, 0, 0 ],
					},
				],
			},
			{
				columns: [
					{
						//margin: [0, 4, 0, 2],
						image: textToBase64Barcode(etiqueta.produto.eans[0]), width: barcodeWidth, height: barcodeHeight,
					},
				],
			},
			{
				columns: [
					{ 	
						bold: true,
						fontSize, 
						width: larguraEtiqueta,
						//margin: [ 0, 2, 0, 0 ],
						text:`${etiqueta.produto.eans[0]}` || '',
					},
				],
			},
			{
				columns: [
					{ 
						bold: true,
						fontSize, 
						width: 'auto',
						//margin: [ 0, 2, 2, 0 ],
						text: imprimirPrecoDoProduto 
							? `${preco}` 
							: '', 
					},
					{ 
						fontSize, 
						width: 'auto',
						//margin: [ 0, 2, 0, 0 ],
						text: imprimirPrecoDoProduto 
							? qtdeLimitadaDoProduto || ''
							: '',
					},
				],
			}],
			margin: [1, 1, 1, 1],
			}]
	} else {
		const preco = imprimirPrecoDoProduto
			? etiqueta.produto.preco?.toLocaleString(
				'pt-BR', { style: 'currency', currency: 'BRL' }
			)
			: etiqueta.precos.map(
				({ precoFinalVarejo }) => precoFinalVarejo.toLocaleString(
					'pt-BR', { style: 'currency', currency: 'BRL' },
				),
			)[0]

		return [
			{stack:[{
				columns: [
					{
						width: larguraEtiqueta,
						fontSize,
						bold: true,
						text: displayNomeCompletoDoProduto(etiqueta.produto),
						//margin: [ 0, 2, 0, 0 ],
					},
				],
			},
			{
				columns: [
					{
						//margin: [0, 4, 0, 2],
						width: barcodeWidth, 
						height: barcodeHeight,
						image: textToBase64Barcode(etiqueta.produto.eans[0]),
					},
				],
			},
			{
				columns: [
					{ 	
						bold: true,
						fontSize, 
						width: larguraEtiqueta,
						//margin: [ 0, 2, 0, 0 ],
						text:`${etiqueta.produto.eans[0]}` || '',
					},
				],
			},
			{
				columns: [
					{ 
						bold: true,
						fontSize, 
						width: 'auto',
						//margin: [ 0, 2, 2, 0 ],
						text: preco ? preco : '', 
					},
					{ 
						fontSize, 
						width: 'auto',
						//margin: [ 0, 2, 0, 0 ],
						text:  qtdeLimitadaDoProduto  || '',
					},
				],
			}],
			margin:[1, 1, 1, 1],
			}]
	}
}

export async function imprimirEtiquetasDaGondola(etiquetas: EtiquetaDePreco[], precoDoProduto: boolean, incluirNome: boolean, imprimirConformeRegraDeNegocioDoCaixa: boolean): Promise<void> {
	const pdf: string = await gerarEtiquetasDeGondola(etiquetas, precoDoProduto, incluirNome, imprimirConformeRegraDeNegocioDoCaixa)
	return new Promise((resolve, reject) => {
		print({
			printable: pdf,
			type: 'pdf',
			base64: true,
			onError: reject,
			onLoadingEnd: resolve,
		})
	})
}

export async function imprimirEtiquetasDeProduto(etiquetas: EtiquetaDePreco[], precoDoProduto: boolean, imprimirConformeRegraDeNegocioDoCaixa: boolean): Promise<void> {
	const pdf: string = await gerarEtiquetasDeProduto(etiquetas, precoDoProduto, imprimirConformeRegraDeNegocioDoCaixa)
	return new Promise((resolve, reject) => {
		print({
			printable: pdf,
			type: 'pdf',
			base64: true,
			onError: reject,
			onLoadingEnd: resolve,
		})
	})
}

export async function imprimirEtiquetasDePrecosDoProduto(etiquetas: EtiquetaDePreco[], precoDoProduto: boolean, incluirNome: boolean, imprimirConformeRegraDeNegocioDoCaixa: boolean): Promise<void> {
	const pdf: string = await gerarEtiquetasDePrecosDoProduto(etiquetas, precoDoProduto, incluirNome, imprimirConformeRegraDeNegocioDoCaixa)
	return new Promise((resolve, reject) => {
		print({
			printable: pdf,
			type: 'pdf',
			base64: true,
			onError: reject,
			onLoadingEnd: resolve,
		})
	})
}

function formatarPrecoQuantidade(preco: ItemDaTabelaDePreco, incluirNome: boolean) {
	const qtdeLimitadaDoProduto = preco.qtdeLimitadaDoProduto ? ` - Limitação ${preco.qtdeLimitadaDoProduto}` : ''
	const nomeDoPlano = preco.tabela.tipoDeCliente?.nome || 'Varejo'
	const margem = nomeDoPlano?.toUpperCase() !== 'CLUBE' ? 14 : 15
	const eVarejo = nomeDoPlano === 'Varejo'

	return incluirNome
		? `${nomeDoPlano.toUpperCase().padEnd(margem - nomeDoPlano.length, ' ')}-`
		+ ` R$ ${formatarMoeda(preco.precoFinalVarejo)}`
		+ (eVarejo
			? ''
			: qtdeLimitadaDoProduto
		)
		: ` R$${formatarMoeda(preco.precoFinalVarejo)}`
		+ (eVarejo
			? ''
			: qtdeLimitadaDoProduto
		)
}
  

function ordenarTiposDeClientePorOrdemAlfabetica(itemAtual: ItemDaTabelaDePreco, proximoItem: ItemDaTabelaDePreco) {
	const tipoDeClienteAtual = itemAtual.tabela.tipoDeCliente?.nome.toUpperCase() || 'VAREJO'
	const proximoTipoDeCliente = proximoItem.tabela.tipoDeCliente?.nome.toUpperCase() || 'VAREJO'
	return tipoDeClienteAtual === proximoTipoDeCliente ? 0 : (tipoDeClienteAtual > proximoTipoDeCliente ? 1 : -1)
} */

export async function imprimirEtiquetasDePreco(etiquetas: EtiquetaDePreco[], incluirPreco: boolean, 
	incluirNome: boolean, conformeRegraDoCaixa: boolean, idLoja?: string) {
	const response: any = await request.post("/etiquetas/imprimir-etiqueta-de-preco", etiquetas, {
		params: {incluirPreco, incluirNome, conformeRegraDoCaixa, idLoja},
		responseType: 'arraybuffer' })
		.catch(async error => {
			if (error?.response?.data) {
				let dataJson
				try {
					dataJson = JSON.parse(
						new TextDecoder('utf-8').decode(error.response.data),
					)
					// eslint-disable-next-line no-empty
				} catch { }
				if (dataJson) {
					throw new Error(dataJson)
				}
			}
			throw error
		})

	imprimePdf(response, "etiquetaProduto")
}

function imprimePdf(response: any, nomeDoArquivo: string) {
	const url = window.URL.createObjectURL(new Blob([response]))
	return Promise.race([
		new Promise<void>((resolve, reject) => {
			print({
				documentTitle: `${nomeDoArquivo}.pdf`,
				printable: url,
				onError: error => reject(error),
				onLoadingEnd: () => resolve(),
			})
		}),
		new Promise((resolve, reject) =>
			setTimeout(
				() => reject('Erro ao gerar impressão, verifique as configurações'),
				15000,
			),
		),
	])
}